import { Review, Notes } from '../../../types'
import type { ColumnType } from '../../../components/AdminDataTable'
import { reviewNotes } from '../../../utils/review'
import Note from '../../../components/Note'
import { Text } from '@mantine/core'
import dayjs from 'dayjs'
import { truncate } from 'lodash'

export const getColumns = (): ColumnType<Review>[] => [
  {
    accessor: 'vehicle',
    title: 'Véhicule',
    width: 280,
    render: (review) => {
      const vehicle = review.vehicle_version
      if (!vehicle) return null
      return (
        <div>
          <Text size="sm" fw={500}>{vehicle.brand?.title} {vehicle.modele}</Text>
          <Text size="xs" c="dimmed" mt={2}>{vehicle.sra_commercial}</Text>
        </div>
      )
    },
  },
  {
    accessor: 'note',
    title: 'Note',
    textAlign: 'center',
    sortable: true,
    width: 90,
    render: (review) => <Note note={review.note} size="small" />,
  },
  ...(reviewNotes.map((note) => ({
    accessor: note.name,
    title: truncate(note.label, { length: 15 }),
    textAlign: 'center' as const,
    sortable: true,
    width: 120,
    render: (review: Review) => {
      const value = (review as Review & Notes)[note.name as keyof Notes]
      return <Note note={value} size="small" />
    },
  }))),
  {
    accessor: 'created_at',
    title: 'Date',
    textAlign: 'center',
    width: 140,
    render: (review) => (
      <Text size="sm" c="dimmed">{dayjs(review.created_at).format('DD/MM/YYYY')}</Text>
    ),
  },
]
